import Vue from "vue";
import VueRouter from "vue-router";
import Landing from "../views/Landing.vue";
import Matchup from "../views/Matchup.vue";
import QuizFinish from "../views/QuizFinish.vue";
import PackageFinish from "../views/PackageFinish.vue";
import DataEnter from "../views/DataEnter.vue";
import IntroPage from "../views/IntroPage.vue";
import PackageStart from "../views/PackageStart.vue";
import PackageForm from "../views/PackageForm.vue";
import store from "@/store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Landing,
    meta: { requiresAuth: true, gtm: "Homepage" },
  },
  {
    path: "/quiz/:projectSlug",
    name: "DataEnter",
    meta: { layout: "matchup", requiresAuth: true, gtm: "Project form" },
    component: DataEnter,
  },
  {
    path: "/intro/:projectSlug",
    name: "IntroPage",
    meta: { layout: "matchup", requiresAuth: true, gtm: "Project intro" },
    component: IntroPage,
  },
  {
    path: "/package/:packageSlug",
    name: "Package",
    meta: { layout: "matchup", requiresAuth: true, gtm: "Package" },
    component: PackageStart,
  },
  {
    path: "/package/:packageSlug/form",
    name: "PackageForm",
    meta: { layout: "matchup", requiresAuth: true, gtm: "Package Form" },
    component: PackageForm,
  },
  {
    path: "/package/:packageSlug/project/:projectSlug",
    name: "IntroPagePackage",
    meta: { layout: "matchup", requiresAuth: true, gtm: "Package Intro" },
    component: IntroPage,
  },
  {
    path: "/matchup/:projectSlug/",
    name: "Matchup",
    meta: { layout: "matchup", requiresAuth: true, gtm: "Project matchup" },
    component: Matchup,
  },
  {
    path: "/package/:packageSlug/matchup/:projectSlug",
    name: "PackageMatchup",
    meta: { layout: "matchup", requiresAuth: true, gtm: "Package matchup" },
    component: Matchup,
  },
  {
    path: "/finished/:projectSlug/",
    name: "Finish",
    meta: { layout: "matchup", requiresAuth: true, gtm: "Project finished" },
    component: QuizFinish,
  },
  {
    path: "/package/:packageSlug/finished/",
    name: "PackageFinish",
    meta: { layout: "matchup", requiresAuth: true, gtm: "Package finished" },
    component: PackageFinish,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters["login/isLoggedIn"]) {
      next();
      return;
    }
    store.dispatch("login/login").then(() => next());
  } else {
    next();
  }
});

export default router;
